import { configureStore, Action } from '@reduxjs/toolkit';
import { ThunkDispatch, ThunkMiddleware } from 'redux-thunk';
import { rootReducer, RootState } from './reducers/rootReducer';
import { thunk } from 'redux-thunk';

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk as unknown as ThunkMiddleware<RootState, any>)
});

export default store;
export type AppDispatch = ThunkDispatch<RootState, any, Action>;
